import axios from "axios";

let activeRequestsCount = 0;
const listeners = new Set();

export const subscribeToRequestCount = (listener) => {
  listeners.add(listener);
  // Emit current state immediately on subscription
  listener(activeRequestsCount);
  return () => {
    listeners.delete(listener);
  };
};

export const getActiveRequestsCount = () => activeRequestsCount;

export const incrementRequest = () => {
  activeRequestsCount++;
  listeners.forEach((l) => l(activeRequestsCount));
};

export const decrementRequest = () => {
  activeRequestsCount = Math.max(0, activeRequestsCount - 1);
  listeners.forEach((l) => l(activeRequestsCount));
};

// Intercept default/global axios requests to automatically track them
axios.interceptors.request.use(
  (config) => {
    if (!config._tracked) {
      config._tracked = true;
      incrementRequest();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config._tracked) {
      decrementRequest();
    }
    return response;
  },
  (error) => {
    if (error && error.config && error.config._tracked) {
      decrementRequest();
    }
    return Promise.reject(error);
  }
);
